import promotionOptions from '../options/promotion';
import moment from 'moment';

export default {
  title: {
    value: '',
    error: null,
    name: 'title',
    placeholder: 'Name',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  text_for_text: {
    value: '',
    error: null,
    name: 'text_for_text',
    placeholder: 'Body',
    breed: 'textarea',
    touched: false,
    isRequired: true,
    validationType: 'length',
    hasBlurred: false,
    inputType: 'textarea',
		charLimit: 135
  },
  promotion_type: {
    value: '',
    error: null,
    name: 'promotion_type',
    placeholder: 'Select Offer/Points',
    breed: 'select',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
    options: promotionOptions,
    displayValue: '',
    isActive: false
  },
  points: {
    value: '',
    error: null,
    hidden: true,
    name: 'points',
    placeholder: 'Points',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  frequency: {
    value: '',
    error: null,
    name: 'frequency',
    placeholder: 'Frequency',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  re_eligible: {
    value: '',
    error: null,
    name: 're_eligible',
    placeholder: 'Days Between',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  max_send: {
    value: '',
    error: null,
    name: 'max_send',
    placeholder: 'Max Send',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  // campaign_type: {
  //   value: '',
  //   error: null,
  //   name: 'timezone',
  //   placeholder: 'Select Time Zone',
  //   breed: 'select',
  //   touched: false,
  //   isRequired: true,
  //   validationType: null,
  //   hasBlurred: false,
  //   inputType: 'text',
	// 	options: timezoneOptions
  // },
}



/** WEBPACK FOOTER **
 ** ./src/forms/survey/createPhase1.js
 **/